export const SEATS_ACCESS_QUICK_FETCH_KEY = 'SeatsAccessQuickFetchKey';